import { init, judgeOverSea, openApp } from '@bilibili/h5-utils'
import { makeInvokeUrl } from '@js/makeShareUrl'
import { outsideBilibili } from '@js/env'
import { initEnv, inBiliApp, biliBridge, isSupport } from '@bilibili/js-bridge'
init() // 判断 ua 类型
judgeOverSea() //  异步判断是否海外，必须跟在 openApp 之前，并且不能与


export function initOpenBiliApp() {
  if (!inBiliApp) {
    const url = makeInvokeUrl('invoke')
    // alert(url)
    const schema = `bilibili://browser/?url=${encodeURIComponent(
        url,
    )}`
    try {
      openApp({
        schema,
        universalLink: url,
        autoDownload: true,
        onlySchema: false,
        // TODO：要修改这里的字段，捞调起数据
        extra: 'h5awaken=gaokao2021',
      })
    } catch (err) {
    }
  }
}
